/* DAPS "6 reasons" landing page — countdown, FAQ accordion, reveal-on-scroll, UGC lightbox.
   The buy box + mobile sticky bar come from the theme's real buy module (daps-buy.js),
   so the prototype's demo selector and fake sticky bar are intentionally NOT here.

   IMPORTANT (theme editor): every "reveal" element starts at opacity:0 and is faded in by JS.
   The Shopify editor re-renders a single section on each edit, so we MUST re-reveal on
   'shopify:section:load' — otherwise an edited section stays invisible ("blank"). In the
   editor (designMode) we skip the fade entirely and show everything immediately. */
(function () {
  'use strict';
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---- countdown (session-persistent, loops; re-queries nodes each tick so editor re-renders keep working) ---- */
  (function () {
    var KEY = 'daps_lp_offer_end';
    var firstNode = document.querySelector('[data-countdown]');
    var mins = firstNode ? (parseInt(firstNode.getAttribute('data-countdown-min') || '15', 10) || 15) : 15;
    var DUR = mins * 60 * 1000;
    function readEnd() {
      var v = 0;
      try { v = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
      if (!v || v - Date.now() > DUR + 2000 || v <= Date.now()) {
        v = Date.now() + DUR;
        try { localStorage.setItem(KEY, String(v)); } catch (e) {}
      }
      return v;
    }
    var end = readEnd();
    function tick() {
      var nodes = document.querySelectorAll('[data-countdown]');
      if (!nodes.length) return;
      var ms = end - Date.now();
      if (ms <= 0) { end = Date.now() + DUR; try { localStorage.setItem(KEY, String(end)); } catch (e) {} ms = DUR; }
      var m = Math.floor(ms / 60000), s = Math.floor((ms % 60000) / 1000);
      var t = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      for (var i = 0; i < nodes.length; i++) nodes[i].textContent = t;
    }
    tick();
    setInterval(tick, 1000);
  })();

  /* ---- FAQ accordion: open one at a time (re-bindable) ---- */
  function initFaq(scope) {
    var items = (scope || document).querySelectorAll('.qa');
    items.forEach(function (d) {
      if (d._faqWired) return;
      d._faqWired = true;
      d.addEventListener('toggle', function () {
        if (d.open) document.querySelectorAll('.qa').forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  /* ---- reveal on scroll (re-inits on editor section load; instant in design mode) ---- */
  var io = null;
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('[data-animate]');
    if (designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (e) { if (!e._revObs) { e._revObs = true; io.observe(e); } });
  }

  /* ---- UGC video lightbox (only wired on cards that carry a real video) ---- */
  var lb = null;
  function ensureLb() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'ugc-lb';
    lb.style.cssText = 'position:fixed;inset:0;z-index:9999;background:rgba(5,10,43,.92);display:none;align-items:center;justify-content:center;padding:20px';
    lb.innerHTML = '<button type="button" aria-label="close" style="position:absolute;top:16px;right:18px;width:42px;height:42px;border:0;border-radius:50%;background:rgba(255,255,255,.16);color:#fff;font-size:24px;line-height:1;cursor:pointer">×</button><video controls playsinline style="max-width:94vw;max-height:86vh;width:auto;height:auto;border-radius:16px;background:#000"></video>';
    document.body.appendChild(lb);
    function close() { var v = lb.querySelector('video'); if (v) { v.pause(); v.removeAttribute('src'); v.load(); } lb.style.display = 'none'; }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.tagName === 'BUTTON') close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return lb;
  }
  function openLb(src) {
    var box = ensureLb();
    var v = box.querySelector('video');
    v.src = src;
    box.style.display = 'flex';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function initUgc(scope) {
    var cards = (scope || document).querySelectorAll('.ugccard[data-ugc-src]');
    cards.forEach(function (c) {
      if (c._ugcWired) return;
      c._ugcWired = true;
      c.style.cursor = 'pointer';
      c.addEventListener('click', function () { openLb(c.getAttribute('data-ugc-src')); });
    });
  }

  function initAll(scope) { initReveal(scope); initFaq(scope); initUgc(scope); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* editor: re-run for the section that just re-rendered (fixes the "goes blank on edit" issue) */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
})();
